import { Chip } from '@mui/material';

export default function ViewOnlyIndicator() {
    return <Chip color="success" variant="outlined" label="VIEWING" sx={{ margin: 0.5 }} />;
}
